import React from "react";
import { cn } from "utils/helpers";

type TemplateStatus = "active" | "locked" | "archived";

type TemplateStatusTagProps = {
	className?: string;
	status: string;
};

export const TemplateStatusTag = ({
	status,
	className = "",
}: TemplateStatusTagProps) => {
	const normalizedStatus = (status?.toLowerCase() ||
		"active") as TemplateStatus;

	const getStatusConfig = (status: TemplateStatus) => {
		switch (status) {
			case "locked":
				return {
					label: "Locked",
					className: "bg-yellow-100 text-yellow-800",
				};
			case "archived":
				return {
					label: "Archived",
					className: "bg-gray-100 text-gray-800",
				};
			case "active":
			default:
				return {
					label: "Active",
					className: "bg-utility-blue-light-50 text-utility-brand-700",
				};
		}
	};

	const config = getStatusConfig(normalizedStatus);

	return (
		<span
			className={cn(
				"rounded-full px-2 py-1 text-xs font-medium",
				config.className,
				className
			)}
		>
			{config.label}
		</span>
	);
};
